import React, { useEffect, useState } from 'react';
import InterviewsTopBar from './InterviewsTopBar';
import InterviewTabsComponent from './InterviewTabsComponent';
import {
	HiringAssessmentDocument,
	HiringAssessmentModelInterface,
	MeetingStatus,
	MeetingType,
	ProctoringStatus,
	UIMeeting,
} from 'types';
import MeetingCard from './MeetingCard';
import MeetingCardV2 from './MeetingCardV2';
import { sendTrackingEvent } from 'src/utils/gtm';
import { BiChevronRight } from 'react-icons/bi';

interface Props {
	meetings?: UIMeeting[];
	campusApplication?: HiringAssessmentDocument[];
	nonCampusApplication?: HiringAssessmentDocument[];
	hiringAssessments?: HiringAssessmentDocument[];
	onClick: () => void;
}

const AssessmentContainer = ({
	meetings,
	campusApplication,
	nonCampusApplication,
	hiringAssessments,
	onClick,
}: Props) => {
	const [tab, setTab] = useState<MeetingStatus>(MeetingStatus.COMPLETED);
	const [inviteTab, setInviteTab] = useState<MeetingStatus | string>('ALL');
	const [filteredMeetings, setFilteredMeetings] = useState<UIMeeting[]>([]);
	const [nonCampusHiringAssessment, setNonCampusHiringAssessment] = useState<HiringAssessmentDocument[]>([]);
	const [campusApplicationAssessment, setCampusApplicationAssessment] = useState<HiringAssessmentDocument[]>([]);
	const [hiringApplicationAssessments, setHiringApplicationAssessments] = useState<HiringAssessmentDocument[]>([]);
	const [showAll, setShowAll] = useState(false);

	useEffect(() => {
		if (tab === MeetingStatus.SCHEDULED) {
			setFilteredMeetings(
				meetings
					? meetings.filter(
							m => [MeetingStatus.SCHEDULED, MeetingStatus.STARTED].includes(m.meetingStatus),
							// && !m?.hiringAssessment,
					  )
					: [],
			);
		} else if (tab === MeetingStatus.COMPLETED) {
			// setFilteredMeetings(
			// 	meetings.filter(
			// 		m =>
			// 			[
			// 				MeetingStatus.COMPLETED,
			// 				MeetingStatus.RESCHEDULED,
			// 				MeetingStatus.JOBSEEKERRESCHEDULED,
			// 				MeetingStatus.JOBSEEKERNOSHOW,
			// 				MeetingStatus.MENTORNOSHOW,
			// 			].includes(m.meetingStatus) &&
			// 			(m?.proctoringCredibility
			// 				? ![ProctoringStatus.Pending, ProctoringStatus.Low].includes(m?.proctoringCredibility)
			// 				: true),
			// 	),
			// );
			setFilteredMeetings(meetings || []);
		}
		if (nonCampusApplication) {
			setNonCampusHiringAssessment(
				nonCampusApplication.map(assessment => ({
					...assessment,
				})) as HiringAssessmentDocument[],
			);
		}
		if (campusApplication) {
			setCampusApplicationAssessment(
				campusApplication.map(assessment => ({
					...assessment,
				})) as HiringAssessmentDocument[],
			);
		}
		if (hiringAssessments) {
			setHiringApplicationAssessments(
				hiringAssessments.map(assessment => ({
					...assessment,
				})) as HiringAssessmentDocument[],
			);
		}
	}, [meetings, tab, hiringAssessments]);
	const filteredData = filteredMeetings.filter(
		m => m.isMock == false && m.meetingType === MeetingType.Interview && (m.meetingStatus === MeetingStatus.COMPLETED && !m?.hiringAssessment),
	);
	const combinedData = [
		// ...campusApplicationAssessment.map(item => ({ ...item, type: 'campusHiringAssessment' })),
		// ...nonCampusHiringAssessment.map(item => ({ ...item, type: 'nonCampusHiringAssessment' })),
		...hiringApplicationAssessments.map(item => ({ ...item, type: 'hiringApplicationAssessment' })),
		...filteredData.map(item => ({ ...item, type: 'meeting' })),
	];

	const handleShowMore = () => {
		setShowAll(!showAll);
	};
	const mockTests = filteredMeetings.filter(
		m =>
			m.isMock == true && m.isGuestUser == false && !m.hiringAssessment && (m.meetingStatus === MeetingStatus.COMPLETED && !m?.hiringAssessment),
	);
	return (
		<>
			<InterviewsTopBar onClick={onClick} />

			{/* <div className="mt-4">
				<InterviewTabsComponent tab={tab} setTab={setTab} />
			</div> */}
			<div>
				<div className="flex flex-row w-full justify-between py-2 pt-6 sm:pt-9 border-b dark:border-[#555770] border-solid">
					<div className="font-inter text-[#1F3343] text-[16px] font-medium leading-[20px]">Interviews</div>

					{combinedData.length > 3 ? (
						<button
							className="flex items-center text-[12px] font-[600] leading-[18px] font-inter text-[#7777E7] dark:text-[#6698FA]"
							onClick={handleShowMore}
						>
							{showAll ? 'Show less' : 'See all'}
							<BiChevronRight size={'16px'} className="ml-[4px] text-[#7777E7]" />
						</button>
					) : null}
				</div>
				<div className="flex justify-center my-5">
					<div className="flex flex-wrap gap-7 sm:flex-col w-full sm:gap-4">
						{combinedData.length ? (
							combinedData.slice(0, showAll ? combinedData.length : 3).map((item, index) => {
								return (
									<div key={index} className="sm:min-w-full min-w-[352px] md:w-[calc(33.3%-19px)]">
										{item.type === 'hiringApplicationAssessment' ? (
											<MeetingCardV2
												onReschedule={onClick}
												hiringAssessmentInvite={item as unknown as HiringAssessmentDocument}
												meeting={undefined}
											/>
										) : (
											// item.type === 'campusHiringAssessment' ? (
											// 	<MeetingCardV2
											// 		onReschedule={onClick}
											// 		hiringAssessmentInvite={item as unknown as HiringAssessmentDocument}
											// 		meeting={undefined}
											// 	/>
											// ) :
											<MeetingCardV2
												onReschedule={onClick}
												meeting={item.type === 'meeting' ? (item as UIMeeting) : undefined}
											/>
										)}
									</div>
								);
							})
						) : (
							<div className="mt-4 w-full h-full flex flex-col justify-center items-center">
								{tab === MeetingStatus.SCHEDULED ? 'No Upcoming Interviews scheduled!' : 'No Completed Interviews!'}
							</div>
						)}
					</div>
				</div>
			</div>
			{mockTests.length ? (
				<div>
					<div className="flex flex-col w-full justify-between py-2 pt-6 sm:pt-9 border-b dark:border-[#555770] border-solid">
						<div className="font-inter text-[#1F3343] text-[16px] font-medium leading-[20px]">Mock Interviews</div>
					</div>
					<div className="flex flex-wrap gap-7 sm:flex-col w-full sm:gap-4 pt-4">
						{mockTests.length ? (
							mockTests.map(m => {
								if (m.isMock == true && m.isGuestUser == false && !m.hiringAssessment) {
									return (
										<div key={m._id} className="sm:min-w-full min-w-[352px] md:w-[calc(33.3%-19px)]">
											<MeetingCardV2 onReschedule={onClick} meeting={m} />
										</div>
									);
								}
							})
						) : (
							<div className=" mt-4 w-full h-full flex flex-col justify-center items-center">
								{tab === MeetingStatus.SCHEDULED
									? 'No Upcoming Mock Interviews scheduled!'
									: 'You Haven’t Taken Any Mock Test Yet!'}
							</div>
						)}
					</div>
				</div>
			) : null}
		</>
	);
};

export default AssessmentContainer;
